import { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { Context } from './Context';
import { useInvites } from '../useInvites';
// TODO: MOVE TO WHERE USED
export function UserInvitesProvider(props) {
    const { children } = props;
    const [sort, setSort] = useState({ order: 'asc', id: 'email' });
    const [search, setSearch] = useState('');
    const [searching, setSearching] = useState(false);
    const [debouncedSearchValue, setDebouncedSearchValue] = useDebounce(search, 450);
    const { invites, initialLoading, error, refetch, loading } = useInvites({ sort, search: debouncedSearchValue });
    const noSearchResults = Boolean(search) && invites.length < 1;
    if (searching && !loading) {
        setSearching(false);
    }
    const handleSearch = (value) => {
        setSearch(value);
        setDebouncedSearchValue(value);
        setSearching(true);
    };
    const value = {
        invites,
        refetch,
        loading: initialLoading,
        error,
        sort,
        setSort,
        setSearch: handleSearch,
        noSearchResults,
        searching,
        searchValue: search,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
